<template>

    <el-tooltip class="box-item w-25" effect="dark" :content="content">
        <img src="../../assets/img/help-circle.png" width="20" />
    </el-tooltip>

</template>

<script setup>

const props = defineProps({
    content: {
        type: String,
        required: true,
    },
});
</script>